import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = { class: "info" }
const _hoisted_3 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["project-card", {wide: _ctx.project.wide}]),
    style: _normalizeStyle(_ctx.styleObject)
  }, [
    _createElementVNode("img", {
      class: "icon",
      src: `images/${_ctx.project.slug}-icon.png`
    }, null, 8, _hoisted_1),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h3", null, _toDisplayString(_ctx.project.title), 1),
      _createElementVNode("p", null, _toDisplayString(_ctx.project.slogan), 1)
    ]),
    (_ctx.project.wide && _ctx.project.screenshot)
      ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          class: _normalizeClass({screenshot: true, shadow: _ctx.project.screenshotShadow ?? true}),
          src: `images/${_ctx.project.slug}-screenshot.png`
        }, null, 10, _hoisted_3))
      : _createCommentVNode("", true)
  ], 6))
}